<ihd-modal
    class="x-dialog-order-refund__modal c-modal--sm"
    [createOverlay]="false"
>
    <div class="c-modal__header">
        <ihd-media
            class="c-media--modal-header c-media__icon--circle c-media__icon--order"
            media="bill-check"
            [heading]="
                'Order.Refund.Title'
                    | translate: { reference: order?.orderReference }
            "
        >
        </ihd-media>
        <ihd-button-group class="ml-auto c-btn-group--gap-3">
            <button
                ihdIconButton
                icon="close"
                class="x-modal__icon-btn c-icon-btn--xs"
                (click)="close()"
            >
                <ihd-tooltip>{{ 'Common.Close' | translate }}</ihd-tooltip>
            </button>
        </ihd-button-group>
    </div>

    <div
        class="c-modal__body"
        [formGroup]="editForm"
        [ihdFormSubmitted]="submitted"
    >
        <div class="c-modal__body-content">
            <div class="c-form-group">
                <label>{{ 'Order.Refund.Reason' | translate }}</label>
                <ihd-dropdown-v2
                    [placeholder]="'Order.Refund.Default' | translate"
                    [items]="refundReasons"
                    formControlName="reason"
                ></ihd-dropdown-v2>
                <ihd-form-messages
                    [form]="editForm"
                    name="reason"
                    [submitted]="submitted"
                >
                    <ihd-form-message name="required">
                        {{ 'Order.Refund.RefundReasonRequired' | translate }}
                    </ihd-form-message>
                </ihd-form-messages>
            </div>
            <div
                class="c-form-group"
                *ngIf="editForm?.get('reason').value?.id === reasonOther"
            >
                <label>{{ 'Order.Refund.Note' | translate }}</label>
                <textarea
                    class="c-form-control"
                    [placeholder]="'Order.Refund.TypeReason' | translate"
                    formControlName="noteOther"
                    rows="3"
                ></textarea>
                <ihd-form-messages
                    [form]="editForm"
                    name="noteOther"
                    [submitted]="submitted"
                >
                    <ihd-form-message name="required"
                        >{{
                            'HelpHint.Required'
                                | translate
                                    : {
                                          name:
                                              ('Order.Refund.Note' | translate)
                                      }
                        }}
                    </ihd-form-message>
                </ihd-form-messages>
            </div>
            <div class="c-modal__actions d-flex justify-content-end">
                <button
                    ihdButton
                    class="c-btn--primary c-btn--wmd c-btn--lg"
                    (click)="sendRequest()"
                    [disabled]="busy"
                >
                    {{ 'Order.Refund.SendRequest' | translate }}
                </button>
            </div>
        </div>
    </div>
</ihd-modal>
